export const QUERY_TAGS = {
  GET_CONFIG: 'getConfig',
  GET_TRANSACTIONS: 'getTransactions',
  GET_AGGREGATE_OVERVIEW: 'getAggregateOverview',
  GET_AGGREGATE_FILTERS: 'getAggregateFilters',
  GET_LANDLORD_STATUS: 'getLandlordStatus',
  GET_LISTING_DETAILS: 'getListingDetails',
  GET_PAYMENT_SETTINGS: 'getLandlordPaymentSettings',
  GET_FEATURE_PERMISSIONS: 'getFeaturePermissions',
  GET_ID_VERIFICATION_INFO: 'getIdVerificationInfo',
  GET_LEDGER: 'getLedgerTransactions',
  GET_LEDGER_FILTERS: 'getLedgerFilters',
  GET_TRANSACTION_DETAILS: 'getTransactionDetails',
  GET_TENANT_INFO: 'getTenantInfo',
} as const;

export type QueryTag = (typeof QUERY_TAGS)[keyof typeof QUERY_TAGS];
